export const pagesConfig = {
  custom: ["404", "parameters", "dev-room", "profile"],
  mappings: {
    dashboard: {
      name: "Dashboard",
      to: "/dashboard/:module",
    },
    parameters: {
      name: "Parametros",
    },
    configuracoes: {
      name: "Configurações",
      to: "/dashboard/configuracoes",
      key: ":module",
    },
    checklist: {
      name: "Pesquisa de Satisfação",
      to: "/dashboard/checklist",
      key: ":module",
    },
    
    add: {
      name: "Cadastro",
    },
    profile: {
      name: "Perfil",
    },
  },
};
